export default "<p>region works!</p>\r\n";